import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";



const SearchResults = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(search).get("q");

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!query) return;

    setLoading(true);
    axios
      .get(`${API_BASE_URL}/api/search?q=${encodeURIComponent(query)}`)
      .then((res) => setResults(res.data))
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>
      <h2 style={{ marginBottom: "10px" }}>
        Search results for “{query}”
      </h2>

      {loading && <p>Searching…</p>}

      {!loading && results.length === 0 && (
        <p>No results found.</p>
      )}

      {results.map((r, i) => (
        <div
          key={i}
          onClick={() => navigate(r.url)}
          style={{
            padding: "14px",
            borderBottom: "1px solid #eee",
            cursor: "pointer"
          }}
        >
          <strong>{r.title}</strong>
          <div style={{ fontSize: "0.9rem", color: "#555" }}>
            {r.category} · {r.type} · {r.suburb} {r.postcode}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchResults;
